import { useState, useEffect } from 'react'
import { useLocation } from 'wouter'
import { Lock, Mail, Shield } from 'lucide-react'
import { useAuth } from '../../contexts/AuthContext'
import { toast } from 'sonner'

export default function AdminLogin() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const { login, isAuthenticated, checkAuth } = useAuth()
  const [, navigate] = useLocation()

  // Verificar se já está autenticado ao carregar a página
  useEffect(() => {
    const verifyAuth = async () => {
      const isValid = await checkAuth()
      if (isValid) {
        console.log('[LOGIN] Usuário já autenticado, redirecionando...')
        navigate('/admin/dashboard')
      }
    }
    verifyAuth()
  }, [checkAuth, navigate])

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/admin/dashboard')
    }
  }, [isAuthenticated, navigate])

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    
    if (!email.trim() || !password.trim()) {
      toast.error('Preencha todos os campos')
      return
    }
    
    setIsLoading(true)

    try {
      await login(email, password)
      toast.success('Login realizado com sucesso!')
      navigate('/admin/dashboard')
    } catch (error: any) {
      console.error('Erro no login:', error)
      toast.error(error.message || 'Erro ao fazer login. Verifique suas credenciais.')
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#1D71C3]/10 to-[#51A64D]/10 p-4">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-2xl shadow-xl p-8">
          <div className="text-center mb-8">
            <div className="w-16 h-16 bg-[#1D71C3] rounded-2xl flex items-center justify-center mx-auto mb-4">
              <Shield size={32} className="text-white" />
            </div>
            <h1 className="text-2xl font-serif font-bold text-gray-900">Painel Administrativo</h1>
            <p className="text-sm text-gray-500 mt-1">PPP Educação Infantil - Porto Velho</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">E-mail</label>
              <div className="relative">
                <Mail size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full pl-10 pr-4 py-2.5 border border-gray-200 rounded-lg focus:border-[#1D71C3] focus:ring-2 focus:ring-[#1D71C3]/20 outline-none transition"
                  placeholder="admin@teste.mail"
                  required
                  autoComplete="username"
                />
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Senha</label>
              <div className="relative">
                <Lock size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full pl-10 pr-4 py-2.5 border border-gray-200 rounded-lg focus:border-[#1D71C3] focus:ring-2 focus:ring-[#1D71C3]/20 outline-none transition"
                  placeholder="••••••••"
                  required
                  autoComplete="current-password"
                />
              </div>
            </div>

            <button
              type="submit"
              disabled={isLoading}
              className="w-full py-3 bg-[#1D71C3] text-white font-semibold rounded-lg hover:bg-[#175FA3] transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {isLoading ? (
                <span className="flex items-center justify-center gap-2">
                  <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                  Entrando...
                </span>
              ) : (
                'Entrar'
              )}
            </button>
          </form>

          <div className="mt-6 pt-6 border-t border-gray-100 text-center">
            <p className="text-xs text-gray-400">
              Área restrita - Acesso autorizado apenas para administradores
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}